// Sequence depending

// Sequence indifferent
require('../library/legacy/core.js');
